<app-form-submission [sessionId]="sessionId" (submission)="closeRefWithSuccess()"></app-form-submission>
